import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/Course/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/Course/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/Course/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/Course/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/Course/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/Course/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}


